var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode === 'editor')?_c('div',[_c('div',{ref:"editor",staticClass:"demo__padding--0 demo__font--16 editor",class:{
        'demo__customScrollbar--brand': !_vm.noScroll,
        'demo__mobdoc--noscroll': _vm.noScroll,
      }}),_vm._t("default")],2):(_vm.validMobiledoc)?_c('div',{staticClass:"demo__mobiledoc-inner-styles",attrs:{"id":_vm.idCopy || undefined}},[(!_vm.justString)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.rendered)}}):_c('div',[_vm._v(" "+_vm._s(_vm.renderedText)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }